import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import PaymentListIn from './list/PaymentListIn';
import PaymentListOut from './list/PaymentListOut';
import './PaymentIndex.scss';
import Withdrawal from "./list/Withdrawal";
import CDKOrderList from "./list/CDKOrderList";
import {inAdminPermissions, inFinance} from "../../../utils/authChecker";
import Reconciliation from "./list/Reconciliation";


function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div p={3}>
          <Typography>{children}</Typography>
        </div>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    // backgroundColor: theme.palette.background.paper,
  },
  tabBar: {
    backgroundColor: 'transparent',
    color: 'white',
    boxShadow: 'none',
  },
}));

export default function PaymentTab(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const { user } = props.auth;
  const isFinance = inFinance(user);
  const isTransactions = inAdminPermissions('Transactions');
  //const [withdrawalNum, setWithdrawalNum] = React.useState(0);
  const { data } = props.admin.tip;
  const withdrawalTip = "WITHDRAWAL"+(data&&data.withdraw?'('+data.withdraw+')':'');
  //const { dateBegin,dateEnd,search } = props.router.params;
  const [search, setSearch] = React.useState("");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const queryWithdrawTip = () =>{
    //const { token } = props.auth;
    if (!props.admin.rollOutsAll.isLoading) {
      //props.getRollOutAll(0,',', '{"tip":true,"approveStatus":"0"}', false, token,0);
    }
  };

  const handleForward = (newValue,search) => {
    setValue(newValue);
    setSearch(search);
  };

  useEffect(() => {
    //if(isFinance&&!isTransactions){
      queryWithdrawTip();
      //setValue(0);
    //}
  }, []);
  return (
    <div className={`admin-users-tab-container ${classes.root}`}>
      <AppBar position="static" className={classes.tabBar}>
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
          {isTransactions && <Tab label="Noiz Wallet History" {...a11yProps(0)} />}
          {isTransactions && <Tab label="Cash Out History" {...a11yProps(1)} />}
          {isFinance&&(<Tab label={withdrawalTip} {...a11yProps(isTransactions?2:0)} />)}
          {isTransactions && <Tab label="Purchase History" {...a11yProps(isFinance?3:2)} />}
          {isTransactions && <Tab label="Platform Reconciliation" {...a11yProps(isFinance?4:3)} />}
        </Tabs>
      </AppBar>
      {isTransactions &&<TabPanel value={value} index={0}>
        <PaymentListIn {...props} search={search}/>
      </TabPanel>}
      {isTransactions &&<TabPanel value={value} index={1}>
        <PaymentListOut {...props} search={search}/>
      </TabPanel>}
      {isFinance&&(<TabPanel value={value} index={isTransactions?2:0}>
        <Withdrawal {...props} />
      </TabPanel>)}
      {isTransactions &&<TabPanel value={value} index={isFinance?3:2}>
        <CDKOrderList {...props} search={search}/>
      </TabPanel>}
      {isTransactions &&<TabPanel value={value} index={isFinance?4:3}>
        <Reconciliation {...props} changeIndex={handleForward}/>
      </TabPanel>}
    </div>
  );
}
